import { Box, Skeleton } from "@mui/material";
import { sphereColors } from "@styles/common-colors";

/** Number of rows to show in sidebar */
const NUMBER_OF_ROWS = 4;

/**
 * Renders a skeleton loading component for the sidebar.
 *
 * @returns {JSX.Element} The SidebarSkeleton component.
 */
export function SidebarSkeleton(): JSX.Element {
  return (
    <Box sx={{ mt: "10px" }}>
      {[...Array(NUMBER_OF_ROWS)].map((_, index) => (
        <Skeleton
          key={index}
          variant="rectangular"
          sx={{
            width: "100%",
            height: "48px",
            mb: "10px",
            backgroundColor: sphereColors.gray100,
          }}
        />
      ))}
    </Box>
  );
}
